import MethodBuilder from "../method-builder";

class PermissionsAPI {
  static get = new MethodBuilder<
    { clientId: number } | { agentId: number } | { hallId: number },
    {
      jackpots: boolean;
      sweepstakes: boolean;
      bonuses: boolean;
      games: boolean;
      lobby: boolean;
      pos: boolean;
      rulesAndTerms: boolean;
      websites: boolean;
      contacts: boolean;
      other: boolean;
    }
  >()
    .withName("Permission.get")
    .build();
}

export default PermissionsAPI;
